import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-wholesaleAccountLogin',
  templateUrl: './wholesaleAccountLogin.component.html',
  styleUrls: ['./wholesaleAccountLogin.component.scss']
})
export class WholesaleAccountLoginComponent implements OnInit {

  message = 'YOU DO NOT HAVE PERMISSION TO SEE WHOLESALE PRICE!';
  constructor() { }

  ngOnInit() {
    var code = localStorage.getItem('code')

    if (code == 'ku') {
      this.message = 'تۆ مۆڵەتت نییە بۆ بینینی نرخی جوملە!';
    }

  }

}
